module.exports = __webpack_public_path__ + "162a48936b49203b2c658e5ac6945467.jpg";